import { render } from "./LayoutSider.vue?vue&type=template&id=2e81ea5c&scoped=true"
import script from "./LayoutSider.vue?vue&type=script&lang=js"
export * from "./LayoutSider.vue?vue&type=script&lang=js"

import "./LayoutSider.vue?vue&type=style&index=0&id=2e81ea5c&scoped=true&lang=css"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e81ea5c"]])

export default __exports__